var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.055 11.078a10.158 10.158 0 0 0-2.223-3.234 10.328 10.328 0 0 0-3.281-2.168 10.365 10.365 0 0 0-4-.793A10.433 10.433 0 0 0 20 7.19a10.433 10.433 0 0 0-6.55-2.309c-1.388 0-2.731.266-4 .794a10.307 10.307 0 0 0-3.282 2.168 10.095 10.095 0 0 0-3.043 7.214c0 1.301.266 2.657.793 4.035.441 1.153 1.074 2.348 1.883 3.555 1.281 1.91 3.043 3.903 5.23 5.922 3.625 3.348 7.215 5.66 7.367 5.754l.926.594c.41.261.938.261 1.348 0l.926-.594c.152-.098 3.738-2.406 7.367-5.754 2.187-2.02 3.95-4.012 5.23-5.922.809-1.207 1.446-2.402 1.883-3.555.527-1.378.793-2.734.793-4.035a9.945 9.945 0 0 0-.816-3.98z",
    fill: "#54585A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heartIcon.c8ae2335.svg";
export { ForwardRef as ReactComponent };